import { graphql } from '@/gql';

export const UpdatePerformanceFinSwimResultMutation = graphql(`
    mutation UpdatePerformanceFinSwimResult($id: ObjectID!, $input: UpdateFinSwimResultInput!) {
        updateFinSwimResult(id: $id, input: $input) {
            ... on UpdateFinSwimResultSuccessfulResponse {
                result {
                    ...FinSwimPerformanceResult
                }
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);
